import { NavigationDirection, VerticalPosition } from './constants';

export const CarouselTransitionEffects = {
  FADE: 'fade',
  COVERFLOW: 'coverflow',
  CARDS: 'cards',
};

export const CarouselControlPlacement = {
  TOP: VerticalPosition.TOP,
  BOTTOM: VerticalPosition.BOTTOM,
  ON_SLIDE: 'on-slide',
  IN_WRAPPER: 'in-wrapper',
};

export const CarouselPaginationType = {
  FRACTION: 'fraction',
  BULLETS: 'bullets',
  ICON_BULLETS: 'icon-bullets',
  TEXT_BULLETS: 'text-bullets',
  TEXT_BULLETS_ALT: 'text-bullets-alt',
  CUSTOM: 'custom',
};

export const CustomPaginationOptions = {
  NO_INDICATORS: 1,
  ICON_INDICATORS: 2,
  TEXT_INDICATORS: 3,
  BULLET_INDICATORS: 4,
};

export const CustomPaginationMap = {
  [CustomPaginationOptions.ICON_INDICATORS]: CarouselPaginationType.ICON_BULLETS,
  [CustomPaginationOptions.TEXT_INDICATORS]: CarouselPaginationType.TEXT_BULLETS,
  [CustomPaginationOptions.BULLET_INDICATORS]: CarouselPaginationType.BULLETS,
};

export const getIndicatorType = (optionInt) => Object.values(CustomPaginationMap)?.[optionInt - 2];

export const handleCustomIndicators = (slides, type) => (
  (type !== CustomPaginationOptions.NO_INDICATORS
    && type !== CustomPaginationOptions.BULLET_INDICATORS)
    ? slides.map((s) => (
      {
        name: s?.iconName,
        height: s?.iconHeight,
      }
    )).filter((s) => s?.name !== null)
    : null
);

export const handleCarouselNavigation = (ref, direction) => (
  (direction === NavigationDirection.PREVIOUS)
    ? ref?.current?.slidePrev()
    : ref?.current?.slideNext());

// Fullscreen functionality
const supportsNativeFullscreen = (element) => !!(
  element?.requestFullscreen
  || element?.webkitRequestFullscreen
);

export const isNativeFullscreen = () => !!(
  document.fullscreenElement
  || document.webkitFullscreenElement
);

const enterFullscreen = (element) => {
  const request = element?.requestFullscreen
    || element?.webkitRequestFullscreen;

  request?.call(element);
};

const exitFullscreen = () => {
  const exit = document.exitFullscreen
    || document.webkitExitFullscreen;

  exit?.call(document);
};

export const toggleCarouselFullscreen = (
  ref,
  setPseudoFullscreen,
) => {
  const element = ref?.current;

  if (!element) return;

  if (supportsNativeFullscreen(element)) {
    if (isNativeFullscreen()) {
      exitFullscreen();
    } else {
      enterFullscreen(element);
    }

    return;
  }

  setPseudoFullscreen((prev) => !prev);
};
